/**
 * Transaction Header Component
 * TASK-213: Build Transaction Detail Modal
 *
 * Displays transaction ID, timestamp, and risk level badge
 */

import React from 'react';
import { format } from 'date-fns';
import AlertBadge from '../dashboard/alerts/AlertBadge';
import { AlertLevel } from '../../types/dashboard';

interface TransactionHeaderProps {
  /** Transaction ID */
  transactionId: string;
  /** ISO 8601 timestamp */
  timestamp: string;
  /** Risk score (0-100) */
  riskScore: number;
  /** Risk level */
  riskLevel: AlertLevel;
}

const TransactionHeader: React.FC<TransactionHeaderProps> = ({
  transactionId,
  timestamp,
  riskScore,
  riskLevel,
}) => {
  // Format timestamp
  const formattedDate = format(new Date(timestamp), 'MMM d, yyyy HH:mm');

  return (
    <div className="flex-1" id="transaction-modal-title">
      <div className="flex items-center gap-3 mb-2">
        <h2 className="text-2xl font-bold text-gray-900">
          Transaction #{transactionId}
        </h2>
        <AlertBadge level={riskLevel} size="lg" showIcon showLabel />
      </div>
      <div className="flex items-center gap-4 text-sm text-gray-600">
        <span>Risk Score: <span className="font-semibold">{riskScore}/100</span></span>
        <span>•</span>
        <span>{formattedDate}</span>
      </div>
    </div>
  );
};

export default TransactionHeader;
